import { getPlaces } from '../../api/standards/places'
import { useRequest } from '../useRequest'

const getStates = () =>
  getPlaces({
    output: 'SMALL',
    reqDirParents: '1',
    reqTypes: '362,221',
  })

export const useStates = () => {
  const { data, ...rest } = useRequest(getStates)

  const states = data?.searchResults?.[0]?.result.map(({ rep }) => rep) || []
  return {
    states,
    ...rest,
  }
}
